const PORTAL_ID = 20902769;

export interface HubspotField {
    name: string;
    value: string;
}

function getHubspotErrorMessage(errorData: any, status: number) {
    const baseMessage = errorData?.message || `Submission failed (status ${status})`;

    if (!Array.isArray(errorData?.errors) || errorData.errors.length === 0) {
        return baseMessage;
    }

    const details = errorData.errors
        .map((error: any) => {
            const field = error?.name || error?.in || "field";
            const message = error?.message || error?.error || "Invalid value";
            return `${field}: ${message}`;
        })
        .join("; ");

    return `${baseMessage} (${details})`;
}

export async function submitToHubspot(formGuid: string, fields: HubspotField[]) {
    const url = `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${formGuid}`;

    const payload = {
        fields,
        context: {
            pageUri: window.location.href,
            pageName: document.title,
        },
    };

    const response = await fetch(url, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const message = getHubspotErrorMessage(errorData, response.status);
        throw new Error(message);
    }

    return await response.json();
}